export function boardName(value) {
  return value === 'New Board' ? '' : value
}
